import { get, post } from '@/utils/request.js'

// 品类列表
export function categoryList(data) {
	return post('business/category/list', data)
}

// 商品列表
export function goodsList(data) {
	return post('business/goods/list', data)
}

// 商品列表分页
export function goodsPage(data) {
	return post('business/goods/goodsPage', data)
}

// 商品列表不分页
export function listForH5(data) {
	return post('business/goods/listForH5', data)
}

// 品牌列表查询
export function brandList(data) {
	return post('business/brand/list', data)
}

// 获取H5首页图
export function h5Image(data) {
	return post('business/goods/h5Image', data)
}